import type { ScheduledOnOff } from "@/views/appLauncher/lib/types"
import { useStore } from "@/composable/useStore"
import { computed, watch } from "@vue/composition-api"
import Utils from "@/utils/utils"

export const useSchedule = () => {
  const { spaceModule } = useStore()

  const schedule = computed(() => {
    return spaceModule.scheduleModule.temp.scheduledOnOff as ScheduledOnOff
  })

  const startTime = computed<number | null>({
    get() {
      const time = schedule.value?.autoStartupAt

      if (time) {
        return new Date(time as string).getTime()
      } else {
        return null
      }
    },
    set(startTime: number | null) {
      if (schedule.value) {
        if (startTime) {
          schedule.value.autoStartupAt = new Date(startTime).toISOString()
        } else {
          schedule.value.autoStartupAt = null
        }
      }
    }
  })

  const startTimeDate = computed(() => {
    if (startTime.value) {
      return Utils.dateWithNamedMonth(new Date(startTime.value).getTime())
    }
    return null
  })

  const startTimeUTC = computed(() => {
    if (startTime.value) {
      const date = new Date(startTime.value)
      const timezone = Utils.minutes(date.getTimezoneOffset())
      const formattedDate = Utils.dateFormatWithTime(date.getTime() + timezone)

      return formattedDate
    }
    return null
  })

  const endTime = computed({
    get() {
      if (schedule.value && schedule.value.autoShutdownAt) {
        return new Date(schedule.value.autoShutdownAt).getTime()
      } else {
        return null
      }
    },
    set(endTime: number | null) {
      if (schedule.value) {
        if (endTime) {
          schedule.value.autoShutdownAt = new Date(endTime).toISOString()
        } else {
          schedule.value.autoShutdownAt = null
        }
      }
    }
  })

  const endTimeDate = computed(() => {
    if (endTime.value) {
      return Utils.dateWithNamedMonth(new Date(endTime.value).getTime())
    }
    return null
  })

  const endTimeUTC = computed(() => {
    if (endTime.value) {
      const date = new Date(endTime.value)
      const timezone = Utils.minutes(date.getTimezoneOffset())
      const formattedDate = Utils.dateFormatWithTime(date.getTime() + timezone)

      return formattedDate
    }
    return null
  })

  watch(schedule, (changes: ScheduledOnOff) => {
    const { autoShutdownAt, autoStartupAt } = changes

    if (autoShutdownAt || autoStartupAt) {
      schedule.value.scheduledOnOffEnabled = true
    } else {
      schedule.value.scheduledOnOffEnabled = false
    }
  })

  return {
    start: {
      startTime,
      startTimeDate,
      startTimeUTC
    },
    end: {
      endTime,
      endTimeDate,
      endTimeUTC
    }
  }
}
